import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { formValueSelector } from 'redux-form'
import { Chart } from 'react-google-charts'

import styles from './style.css'
import { pageRequest } from 'actions/dashboard'
import NoData from './NoData'
import TopItemsByCategoryAllChart from './TopItemsByCategoryAllChart'
import { currencyFormatter, rupiah } from 'utils/formatter'
import ActionBar from './ActionBar'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {browserHistory} from 'react-router'
import BillingReminder from 'components/BillingReminder'
import ChartLoadingSpinner from './ChartLoadingSpinner'

class Dashboard extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    const expireTime = 365 // expire time 1 year
    if (!expired) {
      // TODO HIGH change based on update_filtered_date
      this.props.dispatch(pageRequest())
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
      }
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    const dailyGrossSalesAmount = this._dailyGrossSalesAmount()
    const categorySalesAmountByVolume = this._categorySalesAmountByVolume()
    const categorySalesAmountByRevenue = this._categorySalesAmountByRevenue()
    const dayOfWeekSalesAmount = this._dayOfWeekSalesAmount()
    const hourlySalesAmount = this._hourlySalesAmount()
    const topItems = this._topItems()
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner
    const {moka, subscriptionExpired} = this.props.data
    return (
      <div className='container-full-nosub ng-scope' id='moka-dashboard'>
        <div className={`visible-sm visible-xs ${styles['billing-reminder-dashboard']}`}>
          <BillingReminder user={moka.user} subscriptionExpired={subscriptionExpired} />
        </div>
        <div className='container'>
          <div className='row'>
            <div className={`col-xs-12 ${styles.bottom}`}>
              <div className='row'>
                <ActionBar />
              </div>

              <div className='row'>
                <div className='col-xs-12'>
                  <h2 className={styles['title-section']}>SALES SUMMARY</h2>
                </div>
              </div>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={this.noTransaction() === 0}
                title='No Sales'
                description='You can make transactions through your device, or select different time frame.' />
              {
                this.noTransaction() > 0 &&
                  <div>
                    <div className='row'>
                      <div className='col-xs-12 col-sm-6 col-md-3'>
                        <div className='sales-amount-box'>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.props.data.dashboard.index.gross_sales)}
                          </div>
                          <div className='title-center'>GROSS SALES</div>
                        </div>
                      </div>
                      <div className='col-xs-12 col-sm-6 col-md-3'>
                        <div className='sales-amount-box'>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.props.data.dashboard.index.net_sales)}
                          </div>
                          <div className='title-center'>NET SALES</div>
                        </div>
                      </div>
                      <div className='col-xs-12 col-sm-6 col-md-3'>
                        <div className='sales-amount-box'>
                          <div className={styles['about-box']}>
                            {this.props.data.dashboard.index.total_transactions}
                          </div>
                          <div className='title-center'>NUMBER OF TRANSACTIONS</div>
                        </div>
                      </div>
                      <div className='col-xs-12 col-sm-6 col-md-3'>
                        <div className='sales-amount-box'>
                          <div className={styles['about-box']}>
                            {currencyFormatter(this.avgSales(this.props.data.dashboard.index.net_sales, this.props.data.dashboard.index.total_transactions))}
                          </div>
                          <div className='title-center'>AVG. SALE PER TRANSACTION</div>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      {dailyGrossSalesAmount.data.length > 2 && <div className='col-xs-12'>
                        <div className={styles['sales-chart-box']}>
                          <div className={styles['title-chart-left']}>DAILY GROSS SALES AMOUNT</div>
                          <div className='my-pretty-chart-container'>
                            <Chart
                              chartType='AreaChart'
                              data={dailyGrossSalesAmount.data}
                              options={this.DAILY_SALES_CHART_OPTIONS}
                              graph_id='area-chart-daily'
                              width='100%'
                              height='200px'
                              legend_toggle
                              loader={<ChartLoadingSpinner />}
                          />
                          </div>
                        </div>
                      </div>}
                    </div>
                    <div className='row'>
                      <div className='col-xs-12 col-sm-6 col-md-4'>
                        <div className={styles['sales-chart-box']}>
                          <div className={styles['title-chart-left']}>DAY OF THE WEEK GROSS SALES AMOUNT</div>
                          <div className='my-pretty-chart-container'>
                            <Chart
                              chartType='ColumnChart'
                              data={dayOfWeekSalesAmount.data}
                              options={this.DAY_OF_WEEK_SALES_CHART_OPTIONS}
                              graph_id='area-chart-week'
                              width='100%'
                              height='200px'
                              legend_toggle
                              loader={<ChartLoadingSpinner />}
                          />
                          </div>
                        </div>
                      </div>
                      <div className='col-xs-12 col-sm-6 col-md-8'>
                        <div className={styles['sales-chart-box']}>
                          <div className={styles['title-chart-left']}>HOURLY GROSS SALES AMOUNT</div>
                          <div className='my-pretty-chart-container'>
                            <Chart
                              chartType='AreaChart'
                              data={hourlySalesAmount.data}
                              options={this.HOURLY_SALES_CHART_OPTIONS}
                              graph_id='area-chart-hourly'
                              width='100%'
                              height='200px'
                              legend_toggle
                              loader={<ChartLoadingSpinner />}
                          />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              }

              <div className='row'>
                <div className='col-xs-12'>
                  <h2 className={styles['title-section']}>ITEM SUMMARY</h2>
                </div>
              </div>
              <NoDataAndLoading
                showLoadingSpinner={showLoadingSpinnerPage}
                noDataToDisplay={this.noTransaction() === 0}
                title='No Sales'
                description='You can make transactions through your device, or select different time frame.' />
              {
                this.noTransaction() > 0 &&
                  <div>
                    <div className='row'>
                      <div className='col-xs-12 col-md-4'>
                        <div className={styles['sales-chart-box']}>
                          <div className={styles['title-chart-left']}>CATEGORY BY VOLUME</div>
                          <div className='my-pretty-chart-container'>
                            {!!categorySalesAmountByVolume.rows.length && <Chart
                              chartType='PieChart'
                              rows={categorySalesAmountByVolume.rows}
                              colors={categorySalesAmountByVolume.colors}
                              columns={this.CATEGORY_SALES_BY_VOLUMES_CHART_COLUMNS}
                              options={this.CATEGORY_SALES_BY_VOLUMES_CHART_OPTIONS}
                              graph_id='area-chart-volume'
                              width='100%'
                              height='200px'
                              legend_toggle
                              loader={<ChartLoadingSpinner />}
                          />}
                            {!categorySalesAmountByVolume.rows.length && <NoData />}
                          </div>
                        </div>
                      </div>
                      <div className='col-xs-12 col-md-4'>
                        <div className={styles['sales-chart-box']}>
                          <div className={styles['title-chart-left']}>CATEGORY BY SALES</div>
                          <div className='my-pretty-chart-container'>
                            {!!categorySalesAmountByRevenue.rows.length && <Chart
                              chartType='PieChart'
                              rows={categorySalesAmountByRevenue.rows}
                              colors={categorySalesAmountByRevenue.colors}
                              columns={this.CATEGORY_SALES_BY_REVENUES_CHART_COLUMNS}
                              options={this.CATEGORY_SALES_BY_REVENUES_CHART_OPTIONS}
                              graph_id='area-chart-sales'
                              width='100%'
                              height='200px'
                              legend_toggle
                              loader={<ChartLoadingSpinner />}
                          />}
                            {!categorySalesAmountByRevenue.rows.length && <NoData />}
                          </div>
                        </div>
                      </div>
                      <div className='col-xs-12 col-md-4'>
                        <div className={styles['sales-chart-box']}>
                          <div className={styles['title-chart-left']}>TOP ITEMS</div>
                          <div className='my-pretty-chart-container'>
                            {(topItems.rows.length > 0) && <Chart
                              chartType='Table'
                              columns={this.TOP_ITEMS_CHART_COLUMNS}
                              rows={topItems.rows}
                              options={{}}
                              graph_id='area-chart-top-item'
                              width='100%'
                              height='200px'
                              legend_toggle
                              loader={<ChartLoadingSpinner />}
                          />}
                            {!topItems.rows.length && <NoData />}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-xs-12'>
                        <div className='mk-sales-chart-box'>
                          <div className={styles['title-chart-left']}>TOP ITEMS BY CATEGORY</div>
                          <div className='row'>
                            <TopItemsByCategoryAllChart
                              transactions={this.props.data.dashboard.index.transactions}
                              ChartLoadingSpinner={ChartLoadingSpinner}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }

  avgSales (netSales, numTransaction) {
    return netSales / (numTransaction || 1)
  }

  noTransaction () {
    return this.props.data.dashboard.index.transactions.length
  }

  _dailyGrossSalesAmount = () => {
    let {transactions} = this.props.data.dashboard.index
    let startDate
    let endDate
    if (this.props.search.date) {
      startDate = this.props.search.date.startDate
      endDate = this.props.search.date.endDate
    } else {
      startDate = moment()
      endDate = moment()
    }

    let rows = []
    rows.push([{role: 'domain'}, 'Gross Sales'])
    for (let currentDate = moment(startDate); currentDate.isSameOrBefore(endDate); currentDate.add(1, 'days')) {
      let grossSales = 0
      let numSales = 0
      transactions.forEach((transaction) => {
        if (moment(transaction.date_label).isSame(currentDate, 'day')) {
          transaction.payments.forEach((payment) => {
            grossSales += Math.round(payment.gross_sales)
            numSales += 1
          })
        }
      })
      let dateLabel = currentDate.format('DD-M-YYYY')
      rows.push([
        dateLabel,
        {
          v: grossSales,
          f: rupiah(grossSales) + ' \n Num Sales: ' + numSales
        }
      ])
    }
    return {data: rows}
  }

  _dayOfWeekSalesAmount = () => {
    let {transactions} = this.props.data.dashboard.index
    let data = {}
    // init by day of week
    for (let i = 0; i < 7; i++) {
      data[i] = {grossSales: 0, numSales: 0}
    }
    let days = Object.keys(data)
    let result = []

    // PUSH HEADER
    result.push([{role: 'domain'}, 'Gross Sales'])
    days.forEach((day) => {
      transactions.forEach((transaction) => {
        let transactionDate = moment(transaction.date_label, 'dddd, MMMM DD, YYYY').day()
        if (parseInt(transactionDate) === parseInt(day)) {
          transaction.payments.forEach((payment) => {
            if (!payment.is_refunded) data[day].numSales += 1
            data[day].grossSales += Math.round(payment.gross_sales)
          })
        }
      })
      let dayName = moment().day(day).format('ddd')
      if (data[day].grossSales === 0) {
        result.push([dayName, 0])
      } else {
        result.push([
          dayName,
          {
            v: data[day].grossSales,
            f: rupiah(data[day].grossSales) + ' \n Num Sales: ' + data[day].numSales
          }
        ])
      }
    })

    return {data: result}
  }

  _hourlySalesAmount = () => {
    let {transactions} = this.props.data.dashboard.index
    let data = {}
    let result = []
    for (let i = 0; i < 24; i++) { data[i] = {grossSales: 0, numSales: 0} }
    let hours = Object.keys(data)

    transactions.forEach((transaction) => {
      transaction.payments.forEach((payment) => {
        let hourLabel = moment(new Date(payment.created_at)).format('H')

        hours.forEach((hour) => {
          if (parseInt(hour) === parseInt(hourLabel)) {
            data[hourLabel].grossSales += Math.round(payment.gross_sales)
            if (!payment.is_refunded) data[hourLabel].numSales += 1
          }
        })
      })
    })
    // push header
    result.push([{role: 'domain'}, 'Gross Sales'])
    // push data
    for (let i = 0; i < 24; i++) {
      let hourly = data[i]
      if (hourly.grossSales === 0) {
        result.push([i, 0])
      } else {
        result.push([i, {v: hourly.grossSales, f: rupiah(hourly.grossSales) + ' \n Num Sales: ' + hourly.numSales}])
      }
    }
    return {data: result}
  }

  _categorySalesAmountByRevenue = () => {
    let data = {}
    let colors = []

    let totalRevenue = 0

    let {transactions} = this.props.data.dashboard.index
    transactions.forEach(t => {
      t.payments.forEach(p => {
        totalRevenue += p.total_item_price_amount
      })
    })
    transactions.forEach(t => {
      t.payments.forEach(p => {
        p.checkouts.forEach(c => {
          if (!p.is_refunded) {
            let categoryName = c.category_name

            if (!data.hasOwnProperty(categoryName)) {
              let newColor = this.getRandomColor()
              data[categoryName] = {name: categoryName, colorCode: newColor, revenue: 0}
              colors.push(newColor)
            }

            data[categoryName].revenue += Math.round(c.revenue)
            data[categoryName].percent = data[categoryName].revenue / totalRevenue * 100
          }
        })
      })
    })
    let rows = []
    for (let key in data) {
      let value = data[key]
      rows.push([value.name, value.revenue, value.percent])
    }
    rows = rows.sort((a, b) => {
      return (b[1] - a[1])
    })
    return {rows, colors}
  }

  _categorySalesAmountByVolume = () => {
    let {transactions} = this.props.data.dashboard.index
    let colors = []
    let data = {}
    transactions.forEach((transaction) => {
      transaction.payments.forEach((payment) => {
        let itemSold = payment.checkouts.length
        payment.checkouts.forEach((checkout) => {
          if (!payment.is_refunded) {
            let categoryName = checkout.category_name

            if (!data.hasOwnProperty(categoryName)) {
              let newColor = this.getRandomColor()
              data[categoryName] = {name: categoryName, count: 0, colorCode: newColor, percent: 0}
              colors.push(newColor)
            }

            data[categoryName].count += checkout.quantity
            data[categoryName].percent = data[categoryName].count / itemSold * 100
          }
        }) // end payment checkouts
      }) // end transaction.payments
    }) // end transactions

    let rows = []
    for (let key in data) {
      rows.push([data[key].name, data[key].count, data[key].percent])
    }
    rows = rows.sort((a, b) => {
      return (b[1] - a[1])
    })
    return {rows, colors}
  }

  _topItems = () => {
    let {top_items} = this.props.data.dashboard.index
    let rows = []
    top_items.forEach((item) => {
      rows.push([item.name, item.count, {v: item.revenue, f: rupiah(item.revenue)}])
    })
    return {rows}
  }

  getRandomColor () {
    let letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }

  CATEGORY_SALES_BY_REVENUES_CHART_OPTIONS = {
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    vAxis: {title: 'Category Sales by Sales', gridlines: {count: 0}},
    hAxis: {title: 'Date'},
    is3D: false
  }

  CATEGORY_SALES_BY_REVENUES_CHART_COLUMNS = [
    {id: 'item', label: 'Item', type: 'string'},
    {id: 'sales', label: 'Sales', type: 'number'},
    {id: 'percent', label: 'Percent', type: 'number'}
  ]

  CATEGORY_SALES_BY_VOLUMES_CHART_OPTIONS = {
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    vAxis: {title: 'Category Sales by Volume', gridlines: {count: 20}},
    hAxis: {title: 'Date'},
    is3D: false
  }

  CATEGORY_SALES_BY_VOLUMES_CHART_COLUMNS = [
    {id: 'item', label: 'Item', type: 'string'},
    {id: 'sales', label: 'Sales', type: 'number'},
    {id: 'percent', label: 'Percent', type: 'number'}
  ]

  // Tambahan ada toolTip: isHtml true
  DAY_OF_WEEK_SALES_CHART_OPTIONS = {
    title: '',
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    vAxis: {title: '', gridlines: {count: 10, color: 'transparent'}},
    legend: {position: 'none'},
    hAxis: {title: ''},
    colors: ['#3498DB', '#3498DB'],
    areaOpacity: 1.0
  }

  HOURLY_SALES_CHART_OPTIONS = {
    title: '',
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    legend: {position: 'none'},
    vAxis: {title: '', gridlines: {count: 10, color: 'transparent'}, textStyle: {fontSize: 10}},
    hAxis: {
      title: '',
      gridlines: {count: 24, color: 'transparent'},
      textStyle: {fontSize: 10},
      baselineColor: 'transparent'
    },
    colors: ['#3498DB', '#3498DB'],
    areaOpacity: 1.0
  }

  TOP_ITEMS_CHART_COLUMNS = [
    {'type': 'string', 'label': 'Item'},
    {'type': 'number', 'label': 'Volume'},
    {'type': 'number', 'label': 'Sales'}
  ]

  DAILY_SALES_CHART_OPTIONS = {
    title: '',
    isStacked: true,
    fill: 20,
    displayExactValues: true,
    legend: {position: 'none'},
    vAxis: {title: '', gridlines: {count: 10, color: 'transparent'}},
    hAxis: {title: ''},
    colors: ['#3498DB', '#3498DB'],
    areaOpacity: 1.0
  }
}

Dashboard.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  rupiah: React.PropTypes.func
}

const selector = formValueSelector('search')

// Which props do we want to inject, given the global state?
function select (state) {
  return {
    data: state,
    search: {
      date: selector(state, 'date')
    }
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(select)(Dashboard)



// WEBPACK FOOTER //
// ./app/pages/Dashboard/Dashboard.js